import { useMemo } from 'react';
import { isNil, omitBy } from 'lodash';

import { ensureDefined } from '@e-socna/utils';

import { useReferencesContext } from '../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';

import type { GenericAdminFormValues } from '../types/generic-admin-form-values.type';

export const useInitialValuesFactory = (
  pInitialValues?: GenericAdminFormValues,
) => {
  const referencesContext = useReferencesContext();

  const { defaultGenericStatus } = ensureDefined({
    defaultGenericStatus: referencesContext.defaultGenericStatus,
  });

  const initialValues: GenericAdminFormValues = useMemo(
    () => ({
      statusId: defaultGenericStatus._id,
      ...omitBy(pInitialValues, isNil),
    }),
    [pInitialValues, defaultGenericStatus._id],
  );

  return { initialValues };
};
